module.exports = __webpack_public_path__ + "img/942728f.png";